// extracted by mini-css-extract-plugin
module.exports = {"holder":"accepted-cards_holder__1h275"};